'use strict'

const cloneDeep_ = require('lodash/cloneDeep')
const isEqual_ = require('lodash/isEqual')
const omit_ = require('lodash/omit')

const { dispatchCmd } = require('redux-serial-effects')

const { isSameRecord } = require('../recordStore/records')
const {
  getPaginationData,
  selectCurrentRecord,
  selectCurrentRecordIndex,
  selectDesiredRecordIndex,
  selectFieldsToUpdate,
  selectRefreshCurrentRecord,
  selectRefreshCurrentView,
  selectUpdateSource
} = require('./reducer')

const {
  currentIndexChangedCmd,
  currentViewChangedCmd,
  recordSetLoadedCmd
} = require('../adapters/adapterApiProvider')
const {
  setCurrentIndexCmd,
  setFieldsInCurrentRecordCmd
} = require('../records/provider')
const { fireEventCmd } = require('../helpers/fireEventProvider')
const { resetRefreshCurrentView } = require('./actions')

const omitSystemFields = record =>
  omit_(record, ['_id', '_createdDate', '_updatedDate'])

const subscriber = function({ from, to }, { services: { recordStore } }) {
  const fromCurrentIndex = selectCurrentRecordIndex(from)
  const toCurrentIndex = selectCurrentRecordIndex(to)
  const toDesiredIndex = selectDesiredRecordIndex(to)
  const fromDesiredIndex = selectDesiredRecordIndex(from)
  const toRefreshCurrentRecord = selectRefreshCurrentRecord(to)
  const fromRefreshCurrentRecord = selectRefreshCurrentRecord(from)
  const toRefreshCurrentView = selectRefreshCurrentView(to)
  const actionsToReturn = []

  if (
    (toDesiredIndex >= 0 &&
      toDesiredIndex !== fromDesiredIndex &&
      toDesiredIndex !== toCurrentIndex) ||
    (toRefreshCurrentRecord && !fromRefreshCurrentRecord)
  ) {
    recordStore().matchWith({
      Pending: () => {
        throw new Error('Record store service not ready yet')
      },
      Ready: ({ instance }) => {
        const totalCount = instance.getMatchingRecordCount()
        const realIndex = Math.max(Math.min(toDesiredIndex, totalCount - 1), 0)

        if (fromCurrentIndex !== realIndex || toRefreshCurrentRecord) {
          actionsToReturn.push(setCurrentIndexCmd(realIndex))
        }
      }
    })
  }

  const toFieldsToUpdate = selectFieldsToUpdate(to)
  const fromFieldsToUpdate = selectFieldsToUpdate(from)
  if (fromFieldsToUpdate !== toFieldsToUpdate && toFieldsToUpdate != null) {
    actionsToReturn.push(
      setFieldsInCurrentRecordCmd(
        toFieldsToUpdate,
        toCurrentIndex,
        selectUpdateSource(to)
      )
    )
  }

  if (
    selectCurrentRecordIndex(from) >= 0 &&
    selectCurrentRecordIndex(from) !== selectCurrentRecordIndex(to)
  ) {
    actionsToReturn.push(currentIndexChangedCmd())
    actionsToReturn.push(
      fireEventCmd('currentIndexChanged', selectCurrentRecordIndex(to))
    )
  }

  const fromCurrentRecord = selectCurrentRecord(from)
  const toCurrentRecord = selectCurrentRecord(to)
  if (
    isSameRecord(fromCurrentRecord, toCurrentRecord) &&
    !isEqual_(
      omitSystemFields(fromCurrentRecord),
      omitSystemFields(toCurrentRecord)
    )
  ) {
    actionsToReturn.push(
      fireEventCmd(
        'itemValuesChanged',
        cloneDeep_(fromCurrentRecord),
        cloneDeep_(toCurrentRecord)
      )
    )
  }

  if (getPaginationData(from) !== getPaginationData(to)) {
    actionsToReturn.push(recordSetLoadedCmd())
  }

  if (toRefreshCurrentView) {
    actionsToReturn.push(currentViewChangedCmd())
    actionsToReturn.push(dispatchCmd(resetRefreshCurrentView()))
  }

  return actionsToReturn
}

module.exports = subscriber



// WEBPACK FOOTER //
// ./records/subscriber.js